import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import { ModuleFE_EMInterface, ModuleFE_RuntimeSmartDoc } from '@app/advisor-frontend';
import { DefaultTitle_ProvidersNote, SmartDocType_PhysicianNote } from '@app/advisor-shared';
import './Renderer_QuickNote.scss';
export class Renderer_QuickNote extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.logId = nextProps.logId;
        const log = ModuleFE_RuntimeSmartDoc.cache.unique(state.logId);
        state.logContent = log?.text.body ?? '';
        return state;
    }
    //######################### Logic #########################
    submit = async () => {
        const { logId, logContent } = this.state;
        if (!logContent.length)
            return;
        try {
            if (logId) {
                await ModuleFE_EMInterface.vv1.smartLog.updateProvidersNote({
                    body: logContent,
                    smartLogId: logId
                }).executeSync();
            }
            else {
                await ModuleFE_EMInterface.vv1.smartLog.createProvidersNote({
                    body: logContent,
                    title: DefaultTitle_ProvidersNote,
                    smartDocType: SmartDocType_PhysicianNote
                }).executeSync();
            }
            this.props.onCloseEditor();
        }
        catch (err) {
            this.logError(err);
        }
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'renderer__quick-note', children: [_jsx(TS_TextAreaV2, { type: 'text', placeholder: 'Type here', value: this.state.logContent, onChange: val => this.setState({ logContent: val }) }), _jsxs(LL_H_C, { className: 'renderer__quick-note__actions', children: [_jsx(Button, { variant: 'secondary', onClick: this.props.onCloseEditor, children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: this.submit, disabled: !this.state.logContent.length, children: "Submit" })] })] });
    }
}
//# sourceMappingURL=Renderer_QuickNote.js.map